<div class="filter-container">
  <header>
    <h2>Filters</h2>
    <img
      class="close"
      (click)="closeModal()"
      src="assets/images/close.svg"
      alt=""
    />
  </header>
  <div class="content">
    <div class="show-type" *ngIf="(service | slugText : 'lowercase' : 'yes') === 'psychology'">
          <div class="toggle-filter">
            <button [ngClass]="{'filtered': currentTab === 'In Person'}" (click)="toggleBookingType('In Person')">In Person</button>
            <button [ngClass]="{'filtered': currentTab === 'Online'}" (click)="toggleBookingType('Online')">Telehealth </button>
          </div>
      </div>
    <div class="filter-groups" *ngFor="let item of filterDataByTab()">
      <div *ngIf="item.type === 'radio'" class="radio">
        <label for="" class="field-label heading">{{ item.heading }}</label>
        <mat-radio-group [(ngModel)]="item.value" [name]="item.function">
          <div
            *ngFor="
              let option of getVisibleOptions(
                item.options,
                item.visibleCount,
                item.showAllOptions
              )
            "
          >
            <mat-radio-button [value]="option.value">
              <span class="radio-label">{{ option.name }}</span></mat-radio-button
            >
          </div>
        </mat-radio-group>
        <button
          *ngIf="item?.options?.length > 4"
          class="load-more"
          (click)="toggleOptionsVisibility(item)"
        >
          {{ item.showAllOptions ? "- Show less" : "+ Show more" }}
        </button>
      </div>
      <div *ngIf="item.type === 'checkbox'" class="checkbox">
        <label for="" class="field-label heading">{{ item.heading }}</label>
        <div
          *ngFor="
            let option of getVisibleOptions(
              item.options,
              item.visibleCount,
              item.showAllOptions
            )
          "
        >
          <mat-checkbox
            (change)="getCheckboxValue(option.value, item)"
            [checked]="item.value.indexOf(option.value) > -1"
            ><span class="checkbox-label">{{ option.name }}</span></mat-checkbox
          >
        </div>
        <button
          *ngIf="item?.options?.length > 4"
          class="load-more"
          (click)="toggleOptionsVisibility(item)"
        >
          {{ item.showAllOptions ? "- Show less" : "+ Show more" }}
        </button>
      </div>
    </div>
  </div>
  <footer>
    <button class="transparent-btn" (click)="clearAll()">Clear all</button>
    <button class="primary-btn" (click)="apply()" [disabled]="!isApplied()">Apply</button>
  </footer>
</div>
